import { createContext, type ReactNode } from 'react'

export interface ConfirmOptions {
  title?: ReactNode
  message?: ReactNode
  /** Texto do botão de confirmação — um verbo ("Bloquear visitante", "Remover"). */
  confirmLabel?: ReactNode
  cancelLabel?: ReactNode
  /** Acção destrutiva: botão vermelho e aviso de que não pode ser desfeita. */
  destructive?: boolean
}

export type ConfirmFn = (options: ConfirmOptions) => Promise<boolean>

export const ConfirmContext = createContext<ConfirmFn | null>(null)
